import { createFileRoute } from '@tanstack/react-router';
import { PatientExamsPageContent } from '@/components/paciente/PacienteClinicalPages';

export const Route = createFileRoute('/pep-vida/_authed/pacientes/$cdPaciente/exames')({
  component: ExamesPacientePage,
});

function ExamesPacientePage() {
  const { cdPaciente } = Route.useParams();
  return <PatientExamsPageContent cdPaciente={Number(cdPaciente)} />;
}
